import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/Impressum",
    name: "Impressum",
    component: () => import("../views/Impressum.vue")
  },
  {
    path: "/Datenschutz",
    name: "Datenschutz",
    component: () => import("../views/Datenschutz.vue")
  },
  {
    path: "/Error",
    name: "Error",
    component: () => import("../views/Error.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
